import { useAuth } from "../authContext/useAuth";
import {
  hasCategoryAccess,
  hasSubcategoryAccess,
  isAdminRole,
  isSuperAdminRole,
} from "../utils/permissionConstants";

export const usePermissions = () => {
  const auth = useAuth();
  const { permission, user } = auth;

  return {
    ...auth,
    hasCategoryAccess: (category: string) =>
      hasCategoryAccess(permission, category, user),
    hasSubcategoryAccess: (category: string, subcategory: string) =>
      hasSubcategoryAccess(permission, category, subcategory, user),
    isAdminRole: () => isAdminRole(user),
    isSuperAdminRole: () => isSuperAdminRole(user),
  };
};
